import React, { SVGProps } from "react";

const SvgProtrusion01 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <path
      fill="#b2c4d0"
      d="M143.053 200.499v61.644l142.308-82.405v-61.644l-142.308 82.405z"
    />
    <path fill="#fff" d="M143.053 200.499v61.644L50 123.416l93.053 77.083z" />
    <path
      fill="#309dd6"
      d="m50 123.416 102.23 90.959L300 128.816l-99.62-90.959L50 123.416z"
    />
    <path
      fill="#255d63"
      d="M188.69 201.054v27.456l23.38-13.539v-27.456l-23.38 13.539zM216.965 184.73v27.455l23.381-13.539v-27.455l-23.381 13.539z"
    />
    <g fill="none">
      <path
        stroke="#3f3f3f"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M285.361 137.292v42.446l-142.308 82.405L50 123.416"
      />
      <path
        stroke="#3f3f3f"
        strokeMiterlimit={10}
        d="M143.053 261.075V206.21"
      />
      <path
        stroke="#00232d"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m50 123.416 150.38-85.559L300 128.816l-147.77 85.559L50 123.416z"
      />
    </g>
  </svg>
);

export default SvgProtrusion01;
